import { type FC } from 'react';

import { ProjectsSection } from '@widgets/projects-section';

const ProjectsPage: FC = () => <ProjectsSection />;

export default ProjectsPage;
